import { atom, DefaultValue, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

type UserState = { userName: string, isAdmin: boolean }

const userAtom = atom<UserState | undefined>({
  key: 'userAtom',
  default: undefined,
  // eslint-disable-next-line camelcase
  effects_UNSTABLE: [persistAtom],
});

const userState = selector<string | undefined>({
  key: 'userState',
  get: ({ get }) => get(userAtom)?.userName,
  set: ({ set }, newValue: string | DefaultValue | undefined) => {
    if (typeof newValue === 'string') {
      set(userAtom, {
        userName: newValue,
        isAdmin: newValue.toLowerCase() === 'admin',
      });
    } else {
      set(userAtom, newValue);
    }
  },
});

const adminState = selector<boolean>({
  key: 'adminState',
  get: ({ get }) => !!get(userAtom)?.isAdmin,
});

export {
  userAtom,
  userState,
  adminState,
};
